import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "sendAsSmsNumber", "checkBoxSendAsSmsNumber", "validateMobilePhone" ]

  connect() {
    this.determine_textbox_visibility()
  }

  determine_textbox_visibility() {
    // if this setting is on we always want to show the textbox
    if (this.data.element.dataset.setting == "true") {
      this.sendAsSmsNumberTarget.style.display = 'block'
      this.validateMobilePhoneTarget.value = 'true'
    }
    // if settings is off we only want to show the textbox if checkbox is checked
    else if (this.checkBoxSendAsSmsNumberTarget.checked) {
      this.sendAsSmsNumberTarget.style.display = 'block'
      this.validateMobilePhoneTarget.value = 'true'
    } else {
      this.sendAsSmsNumberTarget.style.display = 'none'
      this.validateMobilePhoneTarget.value = 'false'
    }
  }
}
